
import React from 'react';
import SharedLayout from '@/components/SharedLayout';
import SubpageNavigation from '@/components/SubpageNavigation';

const Kanban = () => {
  return (
    <SharedLayout>
      <div className="text-left px-6 py-12 max-w-4xl mx-auto">
        <SubpageNavigation />
        
        <h2 className="text-3xl font-bold mb-6 text-gray-800 dark:text-gray-100">Kanban Method</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-200">
          Kanban is a visual workflow management method that helps teams visualize work, maximize efficiency, 
          and improve continuously. It uses boards and cards to represent work items and their progress.
        </p>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">Core Principles</h3>
        <ul className="list-disc pl-6 mb-8 text-gray-700 dark:text-gray-200">
          <li className="mb-2"><strong>Visualize Work:</strong> Make all work items visible on a board</li>
          <li className="mb-2"><strong>Limit Work in Progress:</strong> Set limits on how many items can be in progress</li>
          <li className="mb-2"><strong>Manage Flow:</strong> Focus on smooth flow of work through the system</li>
          <li className="mb-2"><strong>Make Policies Explicit:</strong> Clearly define how work moves between stages</li>
          <li className="mb-2"><strong>Improve Collaboratively:</strong> Use metrics and feedback to continuously improve</li>
        </ul>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">Typical Board Structure</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="p-4 bg-yellow-100 dark:bg-yellow-900 rounded-lg">
            <h4 className="font-bold text-yellow-800 dark:text-yellow-200">To Do</h4>
            <p className="text-yellow-700 dark:text-yellow-300 text-sm">Tasks waiting to be started</p>
          </div>
          <div className="p-4 bg-blue-100 dark:bg-blue-900 rounded-lg">
            <h4 className="font-bold text-blue-800 dark:text-blue-200">In Progress</h4>
            <p className="text-blue-700 dark:text-blue-300 text-sm">Currently active tasks</p>
          </div>
          <div className="p-4 bg-green-100 dark:bg-green-900 rounded-lg">
            <h4 className="font-bold text-green-800 dark:text-green-200">Done</h4>
            <p className="text-green-700 dark:text-green-300 text-sm">Completed tasks</p>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
};

export default Kanban;
